import { render, staticRenderFns } from "./FlightIncentivesTab.vue?vue&type=template&id=5f478375&scoped=true&"
import script from "./FlightIncentivesTab.vue?vue&type=script&lang=js&"
export * from "./FlightIncentivesTab.vue?vue&type=script&lang=js&"
import style0 from "./FlightIncentivesTab.vue?vue&type=style&index=0&id=5f478375&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f478375",
  null
  
)

export default component.exports